(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    function initProductCardGalleries() {
    var galleries = document.querySelectorAll('.product-card__gallery[data-gallery]');
    for (var g = 0; g < galleries.length; g++) {
      var gallery = galleries[g];
      if (gallery.dataset.galleryInit) continue;
      var dots = gallery.parentElement.querySelectorAll('.product-card__dot');
      if (dots.length < 2) continue;
      gallery.dataset.galleryInit = 'true';
      var slides = gallery.querySelectorAll('.product-card__slide');
      (function (slides, dots, gallery) {
        var observer = new IntersectionObserver(
          function (entries) {
            for (var i = 0; i < entries.length; i++) {
              if (!entries[i].isIntersecting) continue;
              var index = Array.prototype.indexOf.call(slides, entries[i].target);
              for (var d = 0; d < dots.length; d++) {
                dots[d].classList.toggle('product-card__dot--active', d === index);
              }
            }
          },
          { root: gallery, threshold: 0.6 }
        );
        for (var s = 0; s < slides.length; s++) {
          observer.observe(slides[s]);
        }
      })(slides, dots, gallery);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initProductCardGalleries);
  } else {
    initProductCardGalleries();
  }
  } catch(e) { console.error(e); }
})();

})();
